import React, { useEffect, useState } from 'react';
import './App.css';
import { AppContextProvider } from "./context/appContext/AppContext";
import {
    UserContextProvider
} from "./context/UserContext";
import AppWithContext from "./AppWithContext";
import {BrowserRouter, useLocation} from "react-router-dom";
import {generatePlatformToken} from "./api/generatePlatformToken";
import useView from "./hooks/useView";
import {ToastContextProvider} from "./context/ToastContext";
import PricingPlanModal from "./components/paymentsSection/PricingPlanModal";
import { PaymentFlowProvider } from "./context/PaymentFlowContext";

declare global {
    interface Window {
        ReactNativeWebView?: {
            postMessage: (data: string) => void;
        };
    }
}

const RoutedAppFrame = () => {
    const location = useLocation();
    const pathname = location.pathname.startsWith("/") ? location.pathname.slice(1) : location.pathname;
    const isDashboardPath = location.pathname === "/" || location.pathname.startsWith("/dashboard");

    return (
        <div className={`app path-${pathname} ${isDashboardPath ? "dashboard" : ""}`}>
            <PaymentFlowProvider>
                <AppContextProvider>
                    <AppWithContext />
                </AppContextProvider>
            </PaymentFlowProvider>
        </div>
    );
};

const App = () => {
    const [wasOttHandled, setWasOttHandled] = useState(false);
    const view = useView();

    useEffect(() => {
        handleOtt();
    }, []);

    const handleOtt = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const ott = urlParams.get('ott') || '';
        const platform = urlParams.get('platform') || '';
        if(ott && platform) {
            try {
                const response = await generatePlatformToken(ott, platform);
                localStorage.setItem('token', response.data.message);
                localStorage.setItem('view', 'platform');
            } catch (error) {
                localStorage.removeItem('token');
                localStorage.removeItem('view');
                window.location.href = window.location.href.slice(0, window.location.href.indexOf('?'));
            }
        }
        setWasOttHandled(true);
    }

    if(!wasOttHandled) {
        return null;
    }

    if(view === 'platform') {
        document.body.setAttribute('style', 'background-color: transparent !important');
    }

    return (
        <div id="app-container" className={`app-container ${view ? `${view}-view` : ''}`}>
            <ToastContextProvider>
                <UserContextProvider>
                    <BrowserRouter>
                        <RoutedAppFrame />
                    </BrowserRouter>
                </UserContextProvider>
            </ToastContextProvider>
        </div>
    );
}

export default App;
